import axios from "axios";
import { ApiServices } from "../service/apiServices";

export const getCustomerProfileId = async (body: { fromYear: string | null; toYear: string | null; domainId: string | null }) => {
  const result = await ApiServices.get('/getCustomerProfileId');
  return result;
};

export const getCustomerProfileSummary = async (body: { fromYear: string | null; toYear: string | null; domainId: string | null }) => {
  const result = await ApiServices.post(body,'/getCustomerProfileSummary');
  return result;
};

export const getCustomerProfileEngagement = async (body: { fromYear: string | null; toYear: string | null; domainId: string | null }) => {
  const result = await ApiServices.post(body,'/getCustomerProfileEngagement');
  return result;
};

export const getCustomerProfileClv = async (body: { fromYear: string | null; toYear: string | null; domainId: string | null }) => {
  const result = await ApiServices.post(body,'/getCustomerProfileClv');
  return result;
};

export const getCustomerProfileAvgSpending = async (body: { fromYear: string | null; toYear: string | null; domainId: string | null }) => {
  const result = await ApiServices.post(body,'/getCustomerProfileAvgSpending');
  return result;
};

export const getCustomerProfileChurn = async (body: { fromYear: string | null; toYear: string | null; domainId: string | null }) => {
  const result = await ApiServices.post(body,'/getCustomerProfileChurn');
  return result;
};

export const getCustomerProfileAvgVisit = async (body: { fromYear: string | null; toYear: string | null; domainId: string | null }) => {
  const result = await ApiServices.post(body,'/getCustomerProfileAvgVisit');
  return result;
};